import { APP_CONFIG } from '@/config/index'
import { useGlobalStore } from '@/store/global'

// 系统路由
const routes = [
	{
		name: 'layout',
		path: '/',
		component: () => import('@/layout/index.vue'),
		redirect: () => {
			const menus = useGlobalStore().menus
			return menus?.[0] ? menus?.[0].children[0].path : APP_CONFIG.DASHBOARD_URL
		},
		children: []
	},
	{
		path: '/login',
		component: () => import('@/views/auth/login/login.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/findpwd',
		component: () => import('@/views/auth/findPwd/index.vue'),
		meta: {
			title: '找回密码'
		}
	},
	{
		path: '/callback',
		component: () => import('@/views/auth/login/callback.vue'),
		meta: {
			title: '三方登录'
		}
	},
	{
		path: '/preview',
		component: () => import('@/views/biz/components/preview-file.vue'),
		meta: {
			title: '文件预览'
		}
	},
	{
		path: '/reviewPage',
		component: () => import('@/views/biz/jproject/docCategory/drawer-pageoffice-index.vue'),
		meta: {
			title: '预览审核'
		}
	},
	{
		path: '/largeScreen-dark',
		redirect: '/largeScreen-dark/overallSituation',
		component: () => import('@/views/largeScreen/dark/index.vue'),
		meta: {
			title: '大屏'
		},
		children: [
			{
				path: '/largeScreen-dark/overallSituation',
				component: () => import('@/views/largeScreen/dark/page/overallSituation.vue'),
				meta: {
					title: '综合情况'
				}
			},
			{
				path: '/largeScreen-dark/ProgressStatus',
				component: () => import('@/views/largeScreen/dark/page/ProgressStatus.vue'),
				meta: {
					title: '进度情况'
				}
			},
			{
				path: '/largeScreen-dark/qualityCondition',
				component: () => import('@/views/largeScreen/dark/page/quality-condition.vue'),
				meta: {
					title: '质量情况'
				}
			},
			{
				path: '/largeScreen-dark/securitySituation',
				component: () => import('@/views/largeScreen/dark/page/security-situation.vue'),
				meta: {
					title: '安全情况'
				}
			},
			{
				path: '/largeScreen-dark/acceptanceStatus',
				component: () => import('@/views/largeScreen/dark/page/acceptance-status.vue'),
				meta: {
					title: '验收情况'
				}
			}
		]
	},
	{
		path: '/largeScreen-dark-blue',
		redirect: '/largeScreen-dark-blue/overallSituation',
		component: () => import('@/views/largeScreen/dark-blue/index.vue'),
		meta: {
			title: '大屏'
		},
		children: [
			{
				path: '/largeScreen-dark-blue/overallSituation',
				component: () => import('@/views/largeScreen/dark-blue/page/overallSituation.vue'),
				meta: {
					title: '综合情况'
				}
			},
			{
				path: '/largeScreen-dark-blue/ProgressStatus',
				component: () => import('@/views/largeScreen/dark-blue/page/ProgressStatus.vue'),
				meta: {
					title: '进度情况'
				}
			},
			{
				path: '/largeScreen-dark-blue/qualityCondition',
				component: () => import('@/views/largeScreen/dark-blue/page/quality-condition.vue'),
				meta: {
					title: '质量情况'
				}
			},
			{
				path: '/largeScreen-dark-blue/securitySituation',
				component: () => import('@/views/largeScreen/dark-blue/page/security-situation.vue'),
				meta: {
					title: '安全情况'
				}
			},
			{
				path: '/largeScreen-dark-blue/acceptanceStatus',
				component: () => import('@/views/largeScreen/dark-blue/page/acceptance-status.vue'),
				meta: {
					title: '验收情况'
				}
			}
		]
	},
	{
		path: '/largeScreen-light-blue',
		redirect: '/largeScreen-light-blue/overallSituation',
		component: () => import('@/views/largeScreen/light-blue/index.vue'),
		meta: {
			title: '大屏'
		},
		children: [
			{
				path: '/largeScreen-light-blue/overallSituation',
				component: () => import('@/views/largeScreen/light-blue/page/overallSituation.vue'),
				meta: {
					title: '综合情况'
				}
			},
			{
				path: '/largeScreen-light-blue/ProgressStatus',
				component: () => import('@/views/largeScreen/light-blue/page/ProgressStatus.vue'),
				meta: {
					title: '进度情况'
				}
			},
			{
				path: '/largeScreen-light-blue/qualityCondition',
				component: () => import('@/views/largeScreen/light-blue/page/quality-condition.vue'),
				meta: {
					title: '质量情况'
				}
			},
			{
				path: '/largeScreen-light-blue/securitySituation',
				component: () => import('@/views/largeScreen/light-blue/page/security-situation.vue'),
				meta: {
					title: '安全情况'
				}
			},
			{
				path: '/largeScreen-light-blue/acceptanceStatus',
				component: () => import('@/views/largeScreen/light-blue/page/acceptance-status.vue'),
				meta: {
					title: '验收情况'
				}
			}
		]
	},
	// ============ 任务看板（移动端接口版，v3 2026-10-30；home2 退役入口改 /mobile/home） ============
	{
		// 看板子页（任务管理/我的任务/详情/监管/新建）
		path: '/mobile/board',
		name: 'mobileBoard',
		component: () => import('@/views/mobile/layout/index.vue'),
		redirect: '/mobile/home',
		children: [
			{
				path: 'task-mgmt',
				name: 'mobileBoardTaskMgmt',
				component: () => import('@/views/mobile/board/task-mgmt.vue'),
				meta: { title: '任务管理' }
			},
			{
				path: 'task-mine',
				name: 'mobileBoardTaskMine',
				component: () => import('@/views/mobile/board/task-mine.vue'),
				meta: { title: '我的任务' }
			},
			{
				path: 'task-detail',
				name: 'mobileBoardTaskDetail',
				component: () => import('@/views/mobile/board/task-detail.vue'),
				meta: { title: '任务详情' }
			},
			{
				path: 'task-supervise',
				name: 'mobileBoardTaskSupervise',
				component: () => import('@/views/mobile/board/task-supervise.vue'),
				meta: { title: '任务监管' }
			},
			{
				path: 'task-form',
				name: 'mobileBoardTaskForm',
				component: () => import('@/views/mobile/board/task-form.vue'),
				meta: { title: '新建任务' }
			}
		]
	},
	// ============ 移动端 H5（静态路由；入口显示由 PC 菜单授权控制（GRID_DEFS.pcMenuCode ∈ loginMenu 返回的授权 code 集合），路由本身固定） ============
	{
		path: '/mobile',
		name: 'mobileLayout',
		component: () => import('@/views/mobile/layout/index.vue'),
		redirect: '/mobile/home',
		children: [
			{
				path: 'home',
				name: 'mobileHome',
				component: () => import('@/views/mobile/home/index.vue'),
				meta: { title: '工作台' }
			},
			{
				path: 'dailyReport',
				name: 'mobileDailyReport',
				component: () => import('@/views/mobile/dailyReport/index.vue'),
				meta: { title: '填报日报' }
			},
			{ path: 'my', name: 'mobileMy', component: () => import('@/views/mobile/my/index.vue'), meta: { title: '我的' } },
			{
				// 项目列表页（2026-10-29 拆壳）：四个列表页各自带 task-mine 同款共享头部（项目栏+状态分段+搜索，mobile-list-header），
				// 不再共用项目壳 tabs；detail/edit 等全屏页仍在壳内（hideTabs，壳只渲染子路由）
				path: 'project',
				name: 'mobileProject',
				component: () => import('@/views/mobile/project/index.vue'),
				children: [
					{
						path: 'trouble/detail',
						name: 'mobileTroubleDetail',
						component: () => import('@/views/mobile/project/trouble/detail.vue'),
						meta: { title: '问题详情', hideTabs: true }
					},
					{
						path: 'trouble/edit',
						name: 'mobileTroubleEdit',
						component: () => import('@/views/mobile/project/trouble/edit.vue'),
						meta: { title: '问题上报', hideTabs: true }
					},
					{
						path: 'task/detail',
						name: 'mobileTaskDetail',
						component: () => import('@/views/mobile/project/task/detail.vue'),
						meta: { title: '任务详情', hideTabs: true }
					},
					{
						path: 'task/submit',
						name: 'mobileTaskSubmit',
						component: () => import('@/views/mobile/project/task/submit.vue'),
						meta: { title: '提交成果', hideTabs: true }
					},
					{
						path: 'opTask/submit',
						name: 'mobileOpTaskSubmit',
						component: () => import('@/views/mobile/project/opTask/submit.vue'),
						meta: { title: '运维提交', hideTabs: true }
					},
					{
						path: 'doc/detail',
						name: 'mobileDocDetail',
						component: () => import('@/views/mobile/project/doc/detail.vue'),
						meta: { title: '文档详情', hideTabs: true }
					}
				]
			},
			{
				// 四个列表页平级注册（URL 与 name 不变，仅脱离项目壳渲染）
				path: 'project/trouble',
				name: 'mobileTrouble',
				component: () => import('@/views/mobile/project/trouble/index.vue'),
				meta: { title: '问题管理' }
			},
			{
				path: 'project/task',
				name: 'mobileTask',
				component: () => import('@/views/mobile/project/task/index.vue'),
				meta: { title: '监理任务' }
			},
			{
				path: 'project/opTask',
				name: 'mobileOpTask',
				component: () => import('@/views/mobile/project/opTask/index.vue'),
				meta: { title: '运维任务' }
			},
			{
				path: 'project/doc',
				name: 'mobileDoc',
				component: () => import('@/views/mobile/project/doc/index.vue'),
				meta: { title: '监理文档' }
			}
		]
	},
	{
		path: '/mobile/login',
		name: 'mobileLogin',
		component: () => import('@/views/mobile/login/index.vue'),
		meta: { title: '登录' }
	},
	{
		// 未开放提示页：PC 登录态（token 共用）的 type≠1 用户直达 /mobile/** 时由守卫转入
		path: '/mobile/notOpen',
		name: 'mobileNotOpen',
		component: () => import('@/views/mobile/notOpen/index.vue'),
		meta: { title: '未开放使用' }
	}
]

export default routes
